let handleOutsideClick;
export const closeOnOutsideClick = {
  bind (el, binding, vnode) {
    if (!binding.value.active) {return};
    handleOutsideClick = (e) => {
      e.stopPropagation();
      if (e.target == el) {
        vnode.context[binding.value.handler]();
      } 
    }
    document.addEventListener('click', handleOutsideClick);
    document.addEventListener('touchstart', handleOutsideClick);  // For mobile
  },
  unbind () {
    document.removeEventListener('click', handleOutsideClick);
    document.removeEventListener('touchstart', handleOutsideClick);
  }
};